import React from 'react'

export default function Footer() {
  return (
    <footer className='bg-gray-100 border-t py-3'>
        <div className='container mx-auto px-4'>
            <div className='text-center text-gray-600'>
                <p className='text-xs mb-1'>
                    © 2024 Cục Xúc tiến Thương mại - Bộ Công Thương
                </p>
                <p className='text-xs'>
                    Trợ lý số VietradeAI - Hỗ trợ doanh nghiệp Việt Nam phát triển thương mại quốc tế
                </p>
            </div>
        </div>
    </footer>
  )
}
